import { BasePage as CngBasePage } from 'cng-web-lib'
import UploadNmotTable from './UploadNmotTable.js'
import React from 'react'
import TranslationText from 'src/views/nmot/shared/NmotTranslationText'
import useBreadcrumbNameMap from 'src/navigations/breadcrumbs/Breadcrumb_Nmot'

function UploadTablePage(props) {
  const translatedTextsObject = TranslationText()
  const breadcrumbNameMap = useBreadcrumbNameMap()

  return (
    <CngBasePage
      moduleTitle={translatedTextsObject.nmotUpload}
      renderPage={(showSnackbar) => (
        <UploadNmotTable
          showNotification={showSnackbar}
          {...props}
        />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export { UploadTablePage }
